const comments = [
  {
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20woman%20professional%20portrait%20photo%2C%20warm%20natural%20lighting%2C%20friendly%20expression%2C%20minimalist%20cream%20background%2C%20headshot%20style&width=100&height=100&seq=avatar-01-2026&orientation=squarish',
    date: '2小时前',
    content: '之前用其他平台总是卡，换了夫妻影院真的秒播！画质也好，晚上躺床上追了两集《长安十二时辰》，全程无缓冲，太爽了。',
    drama: '《长安十二时辰》',
  },
  {
    name: '追剧小能手',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20man%20portrait%20photo%2C%20warm%20studio%20lighting%2C%20genuine%20smile%2C%20minimalist%20cream%20background%2C%20headshot%20style&width=100&height=100&seq=avatar-02-2026&orientation=squarish',
    date: '5小时前',
    content: '韩剧更新速度真的太给力了，韩国那边刚播完这边就有了，而且全部高清。已经推荐给闺蜜了，一起追《首尔告白》！',
    drama: '《首尔告白》',
  },
  {
    name: '夜行书生',
    avatar: 'https://readdy.ai/api/search-image?query=A%20middle%20aged%20Asian%20man%20portrait%20photo%2C%20warm%20soft%20lighting%2C%20thoughtful%20expression%2C%20minimalist%20cream%20background%2C%20headshot%20style&width=100&height=100&seq=avatar-03-2026&orientation=squarish',
    date: '1天前',
    content: '找了很久的老版《三国演义》全集，在这找到了。资源真全，连一些冷门老剧都有，收藏了。页面也干净，没乱七八糟的广告。',
    drama: '《三国演义》经典版',
  },
  {
    name: '奶茶不加糖',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20woman%20portrait%20photo%2C%20warm%20studio%20lighting%2C%20bright%20smile%2C%20minimalist%20cream%20background%2C%20headshot%20style&width=100&height=100&seq=avatar-04-2026&orientation=squarish',
    date: '2天前',
    content: '投屏功能太好用了，手机找到剧直接投到电视上看，画质居然还是超清。周末和老公一起看《深海密码》，根本停不下来！',
    drama: '《深海密码》',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            剧迷们在说什么
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            来自真实观众的观影体验，听听他们的声音
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-300">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-medium text-foreground-800">{comment.name}</h3>
                  <div className="flex items-center gap-1 text-xs text-accent-500">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-[10px]"></i>
                    </span>
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-[10px]"></i>
                    </span>
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-[10px]"></i>
                    </span>
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-[10px]"></i>
                    </span>
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-[10px]"></i>
                    </span>
                  </div>
                </div>
                <span className="ml-auto text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">
                  {comment.date}
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-2">
                {comment.content}
              </p>
              <p className="text-xs text-primary-500 font-medium">
                正在追：{comment.drama}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}